export function stripAfterChar(string, char = '-') {
  if (typeof string !== 'string') {
    return string;
  }
  return string.split(char)[0];
}
